import React, { useState, useMemo } from 'react';
import { FaEye } from 'react-icons/fa';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

import Header from './templates/Header';
import Footer from './templates/Footer';
import SEO from './templates/SEO';

import gallery1 from '../assets/images/gallery-1.jpeg';
import gallery2 from '../assets/images/gallery-2.jpeg';
import gallery3 from '../assets/images/gallery-3.jpeg';
import gallery4 from '../assets/images/gallery-4.jpeg';
import gallery5 from '../assets/images/gallery-5.png';
import gallery6 from '../assets/images/gallery-6.jpeg';
import gallery7 from '../assets/images/gallery-7.png';
import gallery8 from '../assets/images/gallery-8.png';

// Define your tab labels exactly as in the Edurock template
const tabs = ['Show All', 'Work Station', 'Research', 'Reception', 'Class Room', 'Mentor Room'];

// Map each tab to an array of images (update as needed)
const imagesByCategory = {
    'Show All':[gallery1,gallery2,gallery3,gallery4,gallery5,gallery6,gallery7,gallery8],
  'Work Station': [gallery1, gallery2],
  'Research': [gallery3, gallery4],
  'Reception': [gallery5, gallery6],
  'Class Room': [gallery7],
  'Mentor Room': [gallery8],
};

function Gallery() {
  const [activeTab, setActiveTab] = useState('All');
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  // Compute filtered images based on active tab
  const filteredImages = useMemo(() => {
    if (activeTab === 'All') {
      return Object.values(imagesByCategory).flat();
    }
    return imagesByCategory[activeTab] || [];
  }, [activeTab]);

  // Open Lightbox at given index
  const openLightbox = (index) => {
    setPhotoIndex(index);
    setIsOpen(true);
  };

  return (
    <div>
      <SEO title="Gallery Page" />
      <Header />

<div className="aboutarea__5">
  <div className="container">
    <div className="row">
      <div className="col-12 text-center">
      <div class="herobannerarea__title"><div class="herobannerarea__small__title"><span>Trading in Action</span></div><div class="herobannerarea__title__heading__2 herobannerarea__title__heading__3"><h2>Gallery</h2></div></div>

      </div>
    </div>
  </div>
</div>



      {/* Tabs Navigation */}
      <div className="tabs-container">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`tab-button ${activeTab === tab ? 'active' : ''}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Gallery Grid */}
      <div className="gallery sp_top_30 sp_bottom_70">
        <div className="container-fluid full__width__padding">
          <div className="blogsidebar__content__wraper__2">
            <div className="photo__gallery__img">
              {filteredImages.map((img, idx) => (
                <div className="single__gallery__img" key={idx}>
                  <img loading="lazy" src={img} alt={`Gallery ${idx + 1}`} />
                  <div className="gallery__icon">
                    <button
                      onClick={() => openLightbox(idx)}
                      aria-label="View Image"
                    >
                      <FaEye />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Lightbox */}
      {isOpen && (
        <Lightbox
          mainSrc={filteredImages[photoIndex]}
          nextSrc={filteredImages[(photoIndex + 1) % filteredImages.length]}
          prevSrc={filteredImages[(photoIndex + filteredImages.length - 1) % filteredImages.length]}
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + filteredImages.length - 1) % filteredImages.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % filteredImages.length)
          }
        />
      )}

      <Footer />

      </div>
  );
}

export default Gallery;
